import React from "react";
import "./buttons.scss";

export const CancelIconButton = ({
  onClick,
  testId,
  position = "center",
  inLineStyle = {},
}) => {
  const cssClasses = () => {
    let base = "pfw-btn-cancel sys-color ";

    if (position === "center") {
      return base + " pfw-btn-cancel-center";
    } else if (position === "top-right") {
      return base + " pfw-btn-cancel-top-right";
    }

    return base + " pfw-btn-cancel-center";
  };

  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className={cssClasses()}
      style={inLineStyle}
    >
      <span>&#10005;</span>
    </button>
  );
};

export const ActionButtonA = ({
  onClick,
  children,
  type = "button",
  disabled = false,
  cssClasses = "btn pwm-action-button",
  id = null,
  testId = null,
  inLineStyle = {},
  addtlCssClasses = "",
  ariaLabel = "",
}) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <button
      type={type}
      onClick={(e) => handleClick(e)}
      className={cssClasses + " " + addtlCssClasses}
      disabled={disabled}
      id={id}
      data-testid={testId}
      style={inLineStyle}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
};

export const ActionButton1Small = ({
  children,
  dataTestId,
  ariaLabel,
  disabled,
  onClick,
  type = "submit",
}) => {
  return (
    <button
      aria-label={ariaLabel ? ariaLabel : null}
      data-testid={dataTestId}
      disabled={disabled}
      onClick={onClick}
      className="btn portal-action-button-1"
      type={type}
    >
      {children}
    </button>
  );
};

//This component is used in the Smart Filters. Refactor it to truly use it globally
export const CloseCrossButton1 = ({ name, onClick, dataTestId }) => (
  <button
    onClick={() => onClick(name)}
    className="theresa-close-cross-btn-1 sys-color d-flex align-items-center justify-content-center"
    data-testid={dataTestId}
  >
    &#10005;
  </button>
);
